"use client";
import Link from 'next/link';

export default function Navbar() {
  return (
    <nav className="fixed w-full top-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-8 h-20 flex justify-between items-center">
        <Link href="/" className="text-2xl font-black tracking-tighter uppercase">
          Alshakilee
        </Link>
        
        <div className="hidden md:flex space-x-10 text-[10px] font-black uppercase tracking-[0.2em]">
          <Link href="/shop" className="hover:text-gray-400 transition-colors">Shop</Link>
          <Link href="/fabrics" className="hover:text-gray-400 transition-colors">Fabrics</Link>
          <Link href="/measure" className="hover:text-gray-400 transition-colors">Measure</Link>
          <Link href="/contact" className="hover:text-gray-400 transition-colors">Contact</Link>
        </div>

        <Link href="/measure" className="bg-black text-white px-6 py-2 text-[10px] font-bold uppercase tracking-widest rounded-full hover:bg-gray-800">
          Book Fitting
        </Link>
      </div>
    </nav>
  );
}